import styled from 'styled-components';
import { Link } from 'react-scroll';
import { CTAIconPosition, CTATag } from '../../../atoms/CTA/CTA.constants';
import CTA from '../../../atoms/CTA';
import { useIntl } from 'react-intl';

const CtasWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 45px;

  @media (${(props) => props.theme.searchHero.mobileSwitch}) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

const StyledSearchLink = styled(Link)`
  height: 50px;

  @media (${(props) => props.theme.searchHero.mobileSwitch}) {
    order: 1;
    display: contents;
  }
`;

const StyledAlertLink = styled(Link)`
  @media (${(props) => props.theme.searchHero.mobileSwitch}) {
    order: 2;
  }
`;

const AlertCta = styled(CTA)`
  @media (${(props) => props.theme.searchHero.mobileSwitch}) {
    order: 2;
    margin: 15px 0 0;
  }
`;

const SearchCta = styled(CTA)`
  span {
    padding-left: 80px;
    padding-right: 80px;
    white-space: nowrap;
  }

  @media (${(props) => props.theme.searchHero.mobileSwitch}) {
    order: 1;
    width: 100%;
    display: flex;

    button,
    span {
      width: 100%;
    }
    span {
      padding: 0;
    }
  }
`;

export const jobSearchKey = 'jobsearchOffsetTop';
export const jobAlertKey = 'jobalertOffsetTop';

/**
 * @param {Object} props
 * @param {boolean} props.hasJobAlertCTA
 * @returns {React.ReactElement} The rendered component
 */
const SearchCtas = ({ hasJobAlertCTA }) => {
  const intl = useIntl();

  return (
    <CtasWrapper>
      {hasJobAlertCTA && (
        <StyledAlertLink to={jobAlertKey} smooth={true} duration={800}>
          <AlertCta
            skin="TERTIARY"
            title={intl.formatMessage({
              id: 'searchHeroAnchorLinkText',
            })}
            text={intl.formatMessage({
              id: 'searchHeroAnchorLinkText',
            })}
            type={CTATag.Button}
            icon="ARROW_ANIMATION"
            iconPos={CTAIconPosition.Before}
            isBrand
          />
        </StyledAlertLink>
      )}
      <StyledSearchLink to={jobSearchKey} smooth={true} duration={800}>
        <SearchCta
          skin="PRIMARY"
          title={intl.formatMessage({
            id: 'searchHeroCTAText',
          })}
          text={intl.formatMessage({
            id: 'searchHeroCTAText',
          })}
          type={CTATag.Button}
          isBrand
        />
      </StyledSearchLink>
    </CtasWrapper>
  );
};

export default SearchCtas;
